import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import io from "socket.io-client";
import { useSelector } from "react-redux";
import { getUserId, BASE_URL, SOCKET_BASE_URL } from "./components/Helpers/helpers";

const SocketContext = createContext(null);
export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  const auth = useSelector((state) => state.auth);
  const reduxUser = auth?.user;

  useEffect(() => {
    const userId =
      reduxUser?._id ||
      reduxUser?.UserID ||
      reduxUser?.id ||
      getUserId()?.UserID;

    if (!userId) {
      return;
    }
    const newSocket = io(SOCKET_BASE_URL, {
        query: { userId },
        transports: ["websocket", "polling"],
        forceNew: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 3000,
        upgrade: true,              
        timeout: 20000,             
        rememberUpgrade: true,
    });

    newSocket.on("connect", () => {
        newSocket.emit("register", userId);
    });

    newSocket.on("disconnect", () => {
    });

    newSocket.on("connect_error", (err) => {
      console.error("Socket error:", err.message);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
      setSocket(null);
    };
  }, [reduxUser]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
